module.exports = require("kwai-icon");